export default "__VITE_ASSET__cfa7275b__"